import { put, takeLatest } from 'redux-saga/effects'

import { calendarStatusModule } from '../modules'
import { fetchCalendarStatus } from '../apiModules/calendarStatus'

function* fetchCalendarStatusSaga(action) {
  const response = yield fetchCalendarStatus(action.payload)
  yield put(calendarStatusModule.fetchSuccess(response))
}

export default function* watchCalendarStatusSaga() {
  yield takeLatest(calendarStatusModule.FETCH, fetchCalendarStatusSaga)
}
